// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './TablaRegiones.css'
// Componentes
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'
import { RowRegiones } from './RowRegiones.jsx'

export class TablaRegiones extends React.Component{
    render(){
        let totalRegiones = this.props.regiones.length
        return <div>
            <TablaReg>
                {_.range(0, totalRegiones).map(index=>{
                    let region = this.props.regiones[index]
                    return <RowRegiones
                        ref={index}
                        key={region? region.cutRegion : index}
                        region={region}
                        mes={this.props.mes}
                        correlativo={index+1}
                    />
                })}
            </TablaReg>
        </div>
    }
}
TablaRegiones.propTypes = {
}
let TablaReg = ({children})=>
    <div className={'panel panel-primary'}>
        <div className={'panel-heading'}>Resumen mensual auditorias</div>
        <table className={'table table-striped table-hover no-margin table-condensed '+css.tablaInventariosFCV}>
            <thead>
            <tr>
                <th className={css.thCorrelativo}>#</th>
                <th className={css.thNumero}>RG</th>
                <th className={css.thNombre}>Region</th>
                <th className={css.thPrecio}>Precio</th>
                <th className={css.thRealizadas}>Realizadas</th>
                <th className={css.thTotal}>Total</th>
                <th className={css.thOpcion}>Descargar</th>
            </tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </table>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/auditorias/resumen-mensual/TablaRegiones.jsx